"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappingContext = void 0;
const react_1 = __importDefault(require("react"));
const defaultValue = {};
exports.MappingContext = react_1.default.createContext(defaultValue);
//# sourceMappingURL=mappingContext.js.map